import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在｜拾真社",
    description: "你访问的页面不存在或链接已更新。可返回拾真社首页或进入爆料库查看已求证的档案。",
    path: "/404",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="mx-auto w-full max-w-xl text-center">
          <p className="font-label text-6xl font-bold text-primary-500/80 md:text-7xl">404</p>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面没有找到
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            链接可能已经更新，或者页面尚未公开。你可以回到首页，或者进入爆料库搜索档案号。
          </p>
          <p className="mt-3 font-label text-[12px] text-foreground-400 break-all">{location.pathname}</p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/scoops"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
            >
              <i className="ri-folder-open-line" aria-hidden="true"></i>
              进入爆料库
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}